module.exports = __webpack_public_path__ + "img/ms_my2.952f085c.png";